import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { applyTheme } from "hooks/useVenueTheme";
import { getDefaultTheme } from "services/venue.service";

// Pages outside a venue (login, venue picker) use the environment's default design system.
applyTheme(getDefaultTheme());

export const asyncProvider = async () => {

  ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
asyncProvider();
